import { Link } from 'foundations-components/transitional/components/Link';
import { getUserContactPageUrl } from '../usersUtils';
import { jsx as _jsx } from "react/jsx-runtime";
const UserLink = ({
  userId,
  portalId,
  children,
  external
}) => {
  const userHref = getUserContactPageUrl(userId, portalId);
  return /*#__PURE__*/_jsx(Link, {
    external: external,
    href: userHref,
    target: "_blank",
    children: children
  });
};
export default UserLink;